import ContentLoader from 'react-content-loader';
import { Media } from '@kiwicom/account-global-contexts';

const UpcomingTripPlaceholder = (): JSX.Element => {
  return (
    <>
      <Media greaterThanOrEqual="tablet">
        <ContentLoader
          speed={2}
          width="100%"
          height={300}
          backgroundColor="#D4D9DB"
          foregroundColor="#EFF2F5"
          uniqueKey="UpcomingTrip-123"
        >
          <rect x="0" y="0" height="300" width="48%" />
          <rect x="52%" rx="4" ry="3" y="50" height="20" width="200" />
          <rect x="52%" rx="4" ry="3" y="100" height="40" width="150" />
          <rect x="52%" rx="4" ry="3" y="175" height="25" width="22%" />
          <rect x="75%" rx="4" ry="3" y="175" height="25" width="22%" />
          <rect x="52%" rx="4" ry="3" y="210" height="25" width="22%" />
          <rect x="75%" rx="4" ry="3" y="210" height="25" width="22%" />
        </ContentLoader>
      </Media>
      <Media between={['mediumMobile', 'tablet']}>
        <ContentLoader
          speed={2}
          width="100%"
          height={523}
          backgroundColor="#D4D9DB"
          foregroundColor="#EFF2F5"
          uniqueKey="UpcomingTrip-123"
        >
          <rect x="0" y="0" height="300" width="100%" />
          <rect x="0" rx="4" ry="3" y="324" height="20" width="200" />
          <rect x="0" rx="4" ry="3" y="360" height="35" width="150" />
          <rect x="0" rx="4" ry="3" y="420" height="25" width="48%" />
          <rect x="50%" rx="4" ry="3" y="420" height="25" width="50%" />
          <rect x="0" rx="4" ry="3" y="460" height="25" width="48%" />
          <rect x="50%" rx="4" ry="3" y="460" height="25" width="50%" />
          <rect x="0" rx="4" ry="3" y="500" height="25" width="48%" />
          <rect x="50%" rx="4" ry="3" y="500" height="25" width="50%" />
        </ContentLoader>
      </Media>
      <Media lessThan="mediumMobile">
        <ContentLoader
          speed={2}
          width="100%"
          height={613}
          backgroundColor="#D4D9DB"
          foregroundColor="#EFF2F5"
          uniqueKey="UpcomingTrip-123"
        >
          <rect x="0" y="0" height="300" width="100%" />
          <rect x="0" rx="4" ry="3" y="324" height="20" width="200" />
          <rect x="0" rx="4" ry="3" y="360" height="35" width="150" />
          <rect x="0" rx="4" ry="3" y="420" height="25" width="100%" />
          <rect x="0" rx="4" ry="3" y="460" height="25" width="100%" />
          <rect x="0" rx="4" ry="3" y="500" height="25" width="100%" />
          <rect x="0" rx="4" ry="3" y="540" height="25" width="100%" />
          <rect x="0" rx="4" ry="3" y="580" height="25" width="100%" />
          <rect x="0" rx="4" ry="3" y="620" height="25" width="100%" />
        </ContentLoader>
      </Media>
    </>
  );
};

export default UpcomingTripPlaceholder;
